import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { TabBar, TabButton } from '~/components';
import * as S from './styles';

export default function SubRouteTabs({ styleTab, tabs, ...rest }) {
  const { url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  return (
    <TabBar {...rest} styleTab={styleTab} value={location.pathname}>
      {tabs.map(tab => {
        const { section, icon, label } = tab;
        return (
          <TabButton
            key={section}
            value={`${url}${section}`}
            label={
              <S.CustomNavLink
                onClick={() => history.push(`${url}${section}`)}
                color={
                  styleTab && location.pathname.includes(section)
                    ? styleTab.contrastColor
                    : null
                }
              >
                <S.TabIcon size={30} name={icon} />
                {label}
              </S.CustomNavLink>
            }
          />
        );
      })}
    </TabBar>
  );
}

SubRouteTabs.propTypes = {
  tabs: PropTypes.array,
  styleTab: PropTypes.object,
};

SubRouteTabs.defaultProps = {
  tabs: [],
  styleTab: null,
};
